import React, { FC } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { JobGroupWithTitlesDescDto } from '@domain/rs/code/JobGroupsWithTitlesRs';

import classnames from 'classnames/bind';
import styles from '../jobSelectModal.module.scss';
const cx = classnames.bind(styles);

interface IJobGroupCardProps {
  vo: JobGroupWithTitlesDescDto;
  on: boolean;
  onSelect: () => void;
}

const JobGroupCard: FC<IJobGroupCardProps> = ({ vo, on, onSelect }) => {
  const { code, name } = vo;
  return (
    <li className={cx('listItem')}>
      <a className={cx('btnJobGroup', `type${code}`, { on })} role="button" onClick={onSelect}>
        {name}
      </a>
    </li>
  );
};

interface IJobGroupContentsProps {
  visible: boolean;
  fieldName: string;
  jobGroupList: JobGroupWithTitlesDescDto[];
}

const JobGroupContents: FC<IJobGroupContentsProps> = ({ visible, fieldName, jobGroupList }) => {
  const { control } = useFormContext();
  const { fields, replace, remove } = useFieldArray({
    control,
    name: fieldName,
  });

  const toggleJobGroupList = (item: JobGroupWithTitlesDescDto) => {
    const fieldArray = fields as unknown as JobGroupWithTitlesDescDto[];
    const index = fields.findIndex((findItem: any) => findItem.code === item.code);
    if (index === -1) {
      const newFields = [...fieldArray, item];
      newFields.sort((a, b) => a.code - b.code);
      replace(newFields);
    } else {
      remove(index);
    }
  };

  if (!visible) return null;

  const jobGroupListEl = jobGroupList.map((item) => {
    const isOn = fields.some((findItem: any) => findItem.code === item.code);

    return <JobGroupCard key={item.code} vo={item} on={isOn} onSelect={() => toggleJobGroupList(item)} />;
  });

  return (
    <div className={cx('jobGroupSelectArea')}>
      <strong className={cx('title')}>어떤일을 하고 싶으세요?</strong>
      <p className={cx('desc')}>
        희망하는 직군·직무를 모두 선택해 주세요!
        <br />
        직군·직무 선택에 따라 추천되는 포지션이 달라져요.
      </p>

      <div className={cx('jobGroupArea')}>
        <ul className={cx('jobGroupList')}>{jobGroupListEl}</ul>
      </div>
    </div>
  );
};

export default JobGroupContents;
